import {
  ExpropApplicationOverviewInput,
  ExpropApplicationOverviewOutput,
} from 'switch-shared/modules/client/exprop/exprop.dto';
import {
  ApplicationGroupOverviewInput,
  ApplicationGroupOverviewOutput,
} from 'switch-shared/modules/dashboard/dashboard.dto';
import type {
  PpaSiteOutput,
  PpaSiteQuery,
} from 'switch-shared/modules/dashboard/ppa-site.dto';

import { baseAPI } from './baseAPI.service';
import { API_METHODS, ENDPOINT_URLS } from './config/apiTags';

export const dashboardAPI = baseAPI
  .enhanceEndpoints({
    addTagTypes: [ENDPOINT_URLS.DASHBOARD],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getApplicationMetrics: builder.query<
        ExpropApplicationOverviewOutput,
        ExpropApplicationOverviewInput
      >({
        query: (params) => {
          return {
            method: API_METHODS.GET,
            url: `exprop/applicationOverview`,
            params,
          };
        },
      }),
      getApplicationGroupOverview: builder.query<
        ApplicationGroupOverviewOutput,
        ApplicationGroupOverviewInput
      >({
        query: (params) => ({
          method: API_METHODS.GET,
          url: `${ENDPOINT_URLS.DASHBOARD}/application-group-overview`,
          params,
        }),
        // providesTags: [{ type: ENDPOINT_URLS.DASHBOARD, id: 'GROUP_OVERVIEW' }],
      }),
      getPpaSite: builder.query<PpaSiteOutput, PpaSiteQuery>({
        query: (params) => ({
          method: API_METHODS.GET,
          url: `${ENDPOINT_URLS.DASHBOARD}/ppa-site`,
          params,
        }),
      }),
    }),
  });

export const {
  useGetApplicationMetricsQuery,
  useGetApplicationGroupOverviewQuery,
  useGetPpaSiteQuery,
} = dashboardAPI;

export default dashboardAPI;
